window._addMeToCart = function(e, el) {
  e.preventDefault();
  
  // Get the variant ID from the clicked element
  let variantId = el.getAttribute('data-variant_id');

  if (!variantId) {
    console.error('No variant ID found.');
    return;
  }

  // Prepare the form data to add the product to the cart
  let formData = {
    'items': [
      {
        'id': variantId,
        'quantity': 1
      }
    ]
  };

  // Fetch request to add the product to the cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    // Trigger the drawer to open by dispatching the 'cart:refresh' event
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));

    // Optionally, dispatch the 'product:added' event for further customization
    document.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
      detail: {
        variant: data.items[0]
      }
    }));
  })
  .catch(err => console.error('Error:', err));
};

document.addEventListener('DOMContentLoaded', function() {
    const prevButton = document.querySelector('.prev');
    const nextButton = document.querySelector('.next');
    const galleryItems = document.querySelectorAll('.product-gallery__media.snap-center'); // All gallery items
    const totalItems = galleryItems.length; // Total number of images

    let activeIndex = 0; // Start with the first image as active

    // Function to update the visibility of prev and next buttons based on the current active slide
    function updateArrowVisibility() {
        // Hide or show the prev button based on the active index
        if (activeIndex === 0) {
            prevButton.style.opacity = '0'; // Hide the prev button for the first image
            prevButton.style.pointerEvents = 'none'; // Disable interaction when hidden
        } else {
            prevButton.style.opacity = '0'; // Initially hide, will fade in on hover
            prevButton.style.pointerEvents = 'none'; // Disable interaction initially
        }

        // Hide or show the next button based on the active index
        if (activeIndex === totalItems - 1) {
            nextButton.style.opacity = '0'; // Hide the next button for the last image
            nextButton.style.pointerEvents = 'none'; // Disable interaction when hidden
        } else {
            nextButton.style.opacity = '0'; // Initially hide, will fade in on hover
            nextButton.style.pointerEvents = 'none'; // Disable interaction initially
        }
    }

    // Function to update the active image class
    function updateActiveImage() {
        // Remove the active class from all images
        galleryItems.forEach(item => {
            item.classList.remove('active');
        });

        // Add the active class to the current image
        galleryItems[activeIndex].classList.add('active');
    }

    // Function to show the arrows only when hovering (including hovering over the arrows)
    function handleHover(isHovering) {
        if (isHovering) {
            // Show prev button if not on the first image
            if (activeIndex > 0) {
                prevButton.style.opacity = '1';
                prevButton.style.pointerEvents = 'auto';
            }
            // Show next button if not on the last image
            if (activeIndex < totalItems - 1) {
                nextButton.style.opacity = '1';
                nextButton.style.pointerEvents = 'auto';
            }
        } else {
            // Hide arrows when not hovering
            prevButton.style.opacity = '0';
            nextButton.style.opacity = '0';
            prevButton.style.pointerEvents = 'none';
            nextButton.style.pointerEvents = 'none';
        }
    }

    // Initial setup when the page loads
    updateArrowVisibility();
    updateActiveImage();

    // Add hover event listeners to the gallery container AND the arrow buttons
    galleryItems.forEach(item => {
        item.addEventListener('mouseenter', () => handleHover(true)); // Show arrows on hover
        item.addEventListener('mouseleave', () => handleHover(false)); // Hide arrows when not hovering
    });

    // Keep the arrows visible if hovering over them
    prevButton.addEventListener('mouseenter', () => handleHover(true));
    nextButton.addEventListener('mouseenter', () => handleHover(true));
    prevButton.addEventListener('mouseleave', () => handleHover(false));
    nextButton.addEventListener('mouseleave', () => handleHover(false));

    // Event listeners for carousel navigation
    prevButton.addEventListener('click', function() {
        if (activeIndex > 0) {
            activeIndex--; // Move to the previous image
            updateActiveImage(); // Update active class
            updateArrowVisibility(); // Update button visibility
        }
    });

    nextButton.addEventListener('click', function() {
        if (activeIndex < totalItems - 1) {
            activeIndex++; // Move to the next image
            updateActiveImage(); // Update active class
            updateArrowVisibility(); // Update button visibility
        }
    });
});

if (!customElements.get('custom-countdown-timer')) {
  class CustomCountdownTimer extends HTMLElement {
    constructor() {
      super();
      var _this = this;
      this.elements = {
        days: this.querySelector('.day .num'),
        hours: this.querySelector('.hour .num'),
        minutes: this.querySelector('.min .num'),
        seconds: this.querySelector('.sec .num'),
      }

      // Parsing the existing MM-DD-YYYY format directly
      let splittedTargetDate = this.dataset.date.split('-');
      let splittedTargetTime = this.dataset.time.split(':');

      this.targetDate = {
        day: parseInt(splittedTargetDate[1]), // Day
        month: parseInt(splittedTargetDate[0]) - 1, // Month, zero-based
        year: parseInt(splittedTargetDate[2]), // Year
        hour: parseInt(splittedTargetTime[0]), // Hour
        minute: parseInt(splittedTargetTime[1]), // Minute
        timezoneOffset: parseInt(this.dataset.timezoneOffset), // Timezone offset
      }

      let userTime = new Date();
      let userTimezoneOffset = userTime.getTimezoneOffset() * 60000;

      this.countDownDate = new Date(this.targetDate.year, this.targetDate.month, this.targetDate.day, this.targetDate.hour, this.targetDate.minute, 0, 0).getTime() - this.targetDate.timezoneOffset - userTimezoneOffset;
      
      this.interval = setInterval(_this.updateTime, 1000, _this);
      this.updateTime(_this);
    }

    updateTime(_this) {
      const now = new Date().getTime();
      const distance = _this.countDownDate - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      _this.elements.days.innerHTML = _this.addZero(days);
      _this.elements.hours.innerHTML = _this.addZero(hours);
      _this.elements.minutes.innerHTML = _this.addZero(minutes);
      _this.elements.seconds.innerHTML = _this.addZero(seconds);

      if (distance < 0) {
        _this.innerHTML = "EXPIRED";
        clearInterval(_this.interval);
      }
    }

    addZero(x) {
      return (x < 10 && x >= 0) ? "0" + x : x;
    }
  }

  customElements.define('custom-countdown-timer', CustomCountdownTimer);
}